/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const FileAudio16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray50}
            fillRule="evenodd"
            d="M11.75 7h-5.5a.25.25 0 00-.25.25v4.25A1.5 1.5 0 114.5 10a.904.904 0 01.5.1V3.75A.75.75 0 015.75 3h6.5a.75.75 0 01.75.75v7.75a1.5 1.5 0 11-1.5-1.5.904.904 0 01.5.1V7.25a.25.25 0 00-.25-.25zm-5.5-1h5.5a.25.25 0 00.25-.25V4.5a.5.5 0 00-.5-.5h-5a.5.5 0 00-.5.5v1.25c0 .138.112.25.25.25z"
        />
    </AccessibleSVG>
);

export default FileAudio16;
